import { userService } from '../../services'
import router from './../../router'
import config from '../../config'
import { authHeader } from '../../services/auth-header'

const user = JSON.parse(localStorage.getItem('user'))
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null }

const actions = {
  login ({ dispatch, commit }, { username, password }) {
    commit('loginRequest', { username })
    userService.login(username, password)
      .then(
        user => {
          commit('loginSuccess', user)
          router.push('/')
        },
        error => {
          commit('loginFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  },
  async logout({ commit }) {
    // Call backend first so it can write the LOGOUT audit log entry
    try {
      await fetch(`${config.apiUrl}/auth/logout`, {
        method: 'POST',
        headers: authHeader()
      })
    } catch (_) {
      // Silent fail — always log out locally even if server is unreachable
    }
    userService.logout()   // clears localStorage
    router.push('/login')
    commit('logout')
  },
  register ({ dispatch, commit }, user) {
    commit('registerRequest', user)

    userService.register(user)
      .then(
        user => {
          commit('registerSuccess', user)
          router.push('/login')
          setTimeout(() => {
            // display success message after route change completes
            dispatch('alert/success', 'Registration successful', { root: true })
          })
        },
        error => {
          commit('registerFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
  }
}

const mutations = {
  loginRequest (state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess (state, user) {
    state.status = { loggedIn: true }
    state.user = user
  },
  loginFailure (state) {
    state.status = {}
    state.user = null
  },
  logout (state) {
    state.status = {}
    state.user = null
  }
}


const getters = {
  isAdmin: state => !!(state.user && state.user.isAdmin),
  canCreateInvoice: state => !!(state.user && (state.user.isAdmin || state.user.isCreateInvoice)),
  canModifyInvoice: state => !!(state.user && (state.user.isAdmin || state.user.isUpdateInvoice)),
  isCustomerOnly: state => !!(state.user && state.user.isCustomerOnly),
  canViewInquiries: state => !!(state.user && (state.user.isAdmin || state.user.isViewInquiries))
}

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
